"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuth = void 0;
var FirebaseApp_1 = require("./FirebaseApp");
var Future_1 = require("../../utils/Future");
var Utils_1 = require("../../utils/Utils");
var FirebaseUser_1 = require("./FirebaseUser");
var UserCache_1 = require("../UserCache");
var CoreServiceHelper_1 = require("../provider/airabbi/CoreServiceHelper");
var FirebaseAuth = (function () {
    function FirebaseAuth(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.isInit = false;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " FirebaseAuth#")], args, false));
            }
        };
        this.getUser = function () {
            var user = (0, UserCache_1.loadUser)();
            if (user) {
                return user;
            }
            return undefined;
        };
        this.allowOneUserLogin = function (email) {
            FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(_this.logoutListenerPath).off('value');
            _this.logoutListenerPath = "users/".concat((0, Utils_1.email2UID)(email), "/token");
            FirebaseApp_1.FirebaseApp.GET()
                .firebase.database()
                .ref(_this.logoutListenerPath)
                .on('value', function (snapshot) {
                _this.log('allowOneUserLogin# listener callback');
                var token = snapshot.val();
                var userInCache = _this.getUser();
                if (userInCache &&
                    userInCache.token &&
                    token !== userInCache.token &&
                    userInCache.role === 'student') {
                    _this.log('allowOneUserLogin# token not the same. logout!');
                    if (_this.listener && _this.listener.onMultiLogin) {
                        _this.listener.onMultiLogin();
                    }
                }
                return Promise.resolve();
            }, function (err) { return _this.log(err); });
        };
        this.loginDemoPage = function () {
            return _this.signIn('CodingbarDemo@airabbi.com', 'airabbi');
        };
        this.signIn = function (email, password) {
            var future = new Future_1.Future(Future_1.futureFunc);
            FirebaseApp_1.FirebaseApp.GET()
                .firebase.auth()
                .signInWithEmailAndPassword(email, password)
                .then(function (result) {
                _this.log('signIn#', result);
                if (!result.user) {
                    _this.log('signIn# Sign in with google error! user is undefined!', result);
                    future.reject('Sign in with google error! user is undefined!');
                }
                else {
                    _this.removeUserNewTmpData(result.user.uid, result.user.email, result.user.photoURL)
                        .then(function (newUser) {
                        _this.log('signIn# removeUserNewTmpData# newUser:', newUser);
                        if (!newUser) {
                            _this.fetchUser(result.user.email)
                                .then(function (user) {
                                _this.log('signIn# fetchUser#', user);
                                if (user) {
                                    if (user.role === 'demo') {
                                        var demoUuid = localStorage.getItem('demoUid')
                                            ? localStorage.getItem('demoUid')
                                            : user.uid + '-' + Date.now().toString();
                                        localStorage.setItem('demoUid', demoUuid);
                                        user.uid = demoUuid;
                                    }
                                    FirebaseApp_1.FirebaseApp.GET()
                                        .firebase.database()
                                        .ref("users/".concat((0, Utils_1.email2UID)(result.user.email), "/updated2"))
                                        .set(Date.now())
                                        .then(function () {
                                        _this.log('signIn# set updated time successfully!');
                                    })
                                        .catch(function (err) {
                                        _this.log('signIn# set updated time error', err);
                                    });
                                    FirebaseApp_1.FirebaseApp.GET()
                                        .firebase.database()
                                        .ref("users/".concat((0, Utils_1.email2UID)(result.user.email), "/emailVerified"))
                                        .set(true)
                                        .then(function () {
                                        _this.log('signIn# set emailVerified successfully!');
                                    })
                                        .catch(function (err) {
                                        _this.log('signIn# set emailVerified error', err);
                                    });
                                    future.resolve(user);
                                }
                                else {
                                    var fuser_1 = _this.toUser(result.user);
                                    fuser_1.emailVerified = true;
                                    FirebaseApp_1.FirebaseApp.GET()
                                        .firebase.database()
                                        .ref("users/".concat(fuser_1.uid))
                                        .update(fuser_1)
                                        .then(function () {
                                        _this.log('signIn# update new user successfully!');
                                        future.resolve(fuser_1);
                                    })
                                        .catch(function (err) {
                                        _this.log(JSON.stringify(err));
                                        future.reject(err);
                                    });
                                }
                            })
                                .catch(function (err) { return future.reject(err); });
                        }
                        else {
                            future.resolve(newUser);
                        }
                    })
                        .catch(function (err) { return future.reject(err); });
                }
            })
                .catch(function (err) {
                future.reject(err);
            });
            return future.promise;
        };
        this.fetchUser = function (email) {
            _this.log('fetchUser# email:', email);
            var future = new Future_1.Future(Future_1.futureFunc);
            FirebaseApp_1.FirebaseApp.GET()
                .firebase.database()
                .ref("users/".concat((0, Utils_1.email2UID)(email)))
                .once('value', function (snapshot) {
                var obj = snapshot.val();
                _this.log('fetchUser# val:', obj);
                return future.resolve(_this.toUser(obj));
            })
                .catch(function (err) {
                _this.log('fetchUser# err:', err);
                return future.resolve(undefined);
            });
            return future.promise;
        };
        this.signUp = function (email, psw) {
            var future = new Future_1.Future(function (resolve, reject) {
            });
            FirebaseApp_1.FirebaseApp.GET()
                .firebase.auth()
                .createUserWithEmailAndPassword(email, psw)
                .then(function (result) {
                future.resolve();
            })
                .catch(function (err) {
                future.reject(err);
            });
            return future.promise;
        };
        this.sendVerifiedEmail = function (email, psw) {
            if (!email || !psw) {
                return Promise.reject('blank params error!');
            }
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).sendVerifiedEmail(email, psw);
        };
        this.resendVerifiedEmail = function (email) {
            if (!email) {
                return Promise.reject('blank params error!');
            }
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).resendVerifiedEmail(email);
        };
        this.signInWithFB = function () {
            return new Promise(function (resolve, reject) {
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.auth()
                    .signInWithRedirect(FirebaseApp_1.FirebaseApp.GET().firebaseFacebookProvider)
                    .then(function (result) {
                    if (!result.user) {
                        return reject('Sign in with facebook error! user is undefined!');
                    }
                    else {
                        var user_1 = _this.toUser(result.user);
                        return FirebaseApp_1.FirebaseApp.GET()
                            .firebase.database()
                            .ref("users/".concat(result.user.uid))
                            .update(user_1)
                            .then(function () {
                            resolve(user_1);
                        });
                    }
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
        };
        this.signInWithGoogle = function () {
            return new Promise(function (resolve, reject) {
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.auth()
                    .signInWithRedirect(FirebaseApp_1.FirebaseApp.GET().firebaseGoogleProvider)
                    .then(function (result) {
                    if (!result.user) {
                        return reject('Sign in with google error! user is undefined!');
                    }
                    else {
                        var user_2 = _this.toUser(result.user);
                        return FirebaseApp_1.FirebaseApp.GET()
                            .firebase.database()
                            .ref("users/".concat(result.user.uid))
                            .update({ isEmailVerified: true })
                            .then(function () {
                            resolve(user_2);
                        });
                    }
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
        };
        this.signOut = function () {
            return new Promise(function (resolve, reject) {
                _this.log('signOut# firebase sign out');
                FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(_this.logoutListenerPath).off('value');
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.auth()
                    .signOut()
                    .then(function () {
                    (0, UserCache_1.removeLocalUser)();
                    resolve();
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
        };
        this.getUserDataWithProviderId = function (userInDB, userInAuth) {
            var updatedUser = userInDB ? userInDB : {};
            var providerId = userInAuth.providerData && userInAuth.providerData[0]
                ? userInAuth.providerData[0].providerId
                : '';
            if (providerId === 'facebook.com' || providerId === 'google.com') {
                updatedUser.isEmailVerified = true;
                if (!userInDB) {
                    updatedUser.displayName = userInAuth.displayName;
                    updatedUser.photoURL = userInAuth.photoURL;
                    updatedUser.email = userInAuth.email;
                    updatedUser.phoneNumber = userInAuth.phoneNumber;
                    updatedUser.unit = 'airabbi';
                    updatedUser.role = 'student';
                }
            }
            updatedUser.providerId = providerId;
            return updatedUser;
        };
        this.observeAuth = function () {
            FirebaseApp_1.FirebaseApp.GET()
                .firebase.auth()
                .onAuthStateChanged(function (user) {
                _this.log('observeAuthState#', user);
                if (!user) {
                    _this.isInit = true;
                    (0, UserCache_1.removeLocalUser)();
                    if (_this.listener) {
                        _this.listener.onReAuthNeeded();
                    }
                    return;
                }
                var path = "users/".concat((0, Utils_1.email2UID)(user.email));
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.database()
                    .ref(path)
                    .once('value', function (snapshot) {
                    var updatedUser = snapshot.val();
                    updatedUser = _this.getUserDataWithProviderId(updatedUser ? Object.assign({}, updatedUser) : undefined, user);
                    var unit = updatedUser.unit.toLowerCase();
                    if (window.location.host !== 'school.codingbar.ai' &&
                        unit !== 'codingbar' &&
                        unit !== 'airabbi') {
                        _this.signOut().catch(function (err) { return _this.log('sign out fail. err: ', err); });
                        alert('請用school.codingbar.ai這個網址以帶給您更好的學習體驗!');
                        var url = 'https://school.codingbar.ai';
                        if (window.location.pathname.toLowerCase().includes('aimate')) {
                            url += window.location.pathname;
                        }
                        window.location.href = url;
                        return;
                    }
                    else if (window.location.host === 'school.codingbar.ai' &&
                        (unit === 'codingbar' || unit === 'airabbi')) {
                        _this.signOut().catch(function (err) { return _this.log('sign out fail. err: ', err); });
                        alert('請用app.codingbar.ai這個網址以帶給您更好的學習體驗!');
                        var url = 'https://app.codingbar.ai';
                        if (window.location.pathname.toLowerCase().includes('aimate')) {
                            url += window.location.pathname;
                        }
                        window.location.href = url;
                        return;
                    }
                    updatedUser.token = user.refreshToken;
                    _this.log('observeAuthState# snapshot:', updatedUser);
                    var theUser = _this.toUser(updatedUser);
                    if (theUser.role === 'demo') {
                        var demoUuid = localStorage.getItem('demoUid')
                            ? localStorage.getItem('demoUid')
                            : theUser.uid + '-' + Date.now().toString();
                        localStorage.setItem('demoUid', demoUuid);
                        theUser.uid = demoUuid;
                    }
                    _this.log('observeAuthState# theUser:', theUser);
                    if (theUser) {
                        (0, UserCache_1.updateUser)(theUser);
                    }
                    else {
                        (0, UserCache_1.removeLocalUser)();
                    }
                    FirebaseApp_1.FirebaseApp.GET()
                        .firebase.database()
                        .ref("users/".concat((0, Utils_1.email2UID)(user.email)))
                        .update(theUser)
                        .then(function () {
                        _this.log('observeAuthState# update token success! token: ', user.refreshToken);
                        _this.allowOneUserLogin(user.email);
                    })
                        .catch(function (err) { return _this.log(err); });
                    if (_this.listener) {
                        _this.listener.onUserChanged(theUser);
                        if (_this.listener.onPushBulletin) {
                            _this.listener.onPushBulletin();
                        }
                    }
                })
                    .catch(function (err) {
                    _this.log(err);
                    (0, UserCache_1.removeLocalUser)();
                    if (_this.listener) {
                        _this.listener.onUserChanged(undefined);
                    }
                });
            });
        };
        this.observeAuthState = function (listener) {
            _this.listener = listener;
        };
        this.sendSignInLink = function (email) {
            return FirebaseApp_1.FirebaseApp.GET()
                .firebase.auth()
                .sendSignInLinkToEmail(email, {
                url: 'https://api.codingbar.ai/?email=' + email
            })
                .then(function () {
                return Promise.resolve();
            })
                .catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;
                return Promise.reject(error);
            });
        };
        this.confirmPasswordReset = function (code, newPassword) {
            return FirebaseApp_1.FirebaseApp.GET()
                .firebase.auth()
                .confirmPasswordReset(code, newPassword)
                .then(function () {
                return Promise.resolve();
            })
                .catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;
                return Promise.reject(error);
            });
        };
        this.getContinueUrl = function () {
            switch (FirebaseApp_1.FirebaseApp.GET().env) {
                case 'FUT':
                    return 'https://app.codingbar.ai/login';
                case 'AWS_FUT':
                    return 'https://app.codingbar.ai/login';
                case 'DEV':
                    return 'https://codebar-dev.firebaseapp.com/login';
            }
            return 'https://codebar-dev.firebaseapp.com/login';
        };
        this.sendPasswordReset = function (email) {
            return FirebaseApp_1.FirebaseApp.GET().firebase.auth().sendPasswordResetEmail(email, {
                url: _this.getContinueUrl()
            });
        };
        this.updatePassword = function (newPassword) {
            return FirebaseApp_1.FirebaseApp.GET().firebase.auth().currentUser.updatePassword(newPassword);
        };
        this.cfg = cfg;
        this.log('created!');
    }
    FirebaseAuth.prototype.init = function (env) {
        this.log('init#', env);
        this.env = env;
        this.observeAuth();
        return Promise.resolve();
    };
    FirebaseAuth.prototype.toUser = function (user) {
        return FirebaseUser_1.FirebaseUser.CONVERT(user);
    };
    FirebaseAuth.prototype.removeUserNewTmpData = function (uid, email, photoUrl) {
        var _this = this;
        var future = new Future_1.Future(Future_1.futureFunc);
        FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref("usersnew/".concat((0, Utils_1.email2UID)(email)))
            .once('value', function (snapshot) {
            _this.log('removeUserTempData# val', snapshot.val());
            var newUser = _this.toUser(snapshot.val());
            _this.log('removeUserTempData# newUser', newUser);
            if (newUser) {
                _this.log('removeUserNewTmpData# New User, clone new user data', newUser);
                newUser.uid = (0, Utils_1.email2UID)(email);
                newUser.photoUrl = newUser.photoUrl ? newUser.photoUrl : photoUrl;
                newUser.emailVerified = true;
                newUser.updated = Date.now();
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.database()
                    .ref("users/".concat((0, Utils_1.email2UID)(email)))
                    .update(newUser)
                    .then(function () {
                    _this.log('removeUserNewTmpData# Update new user successfully!');
                    future.resolve(newUser);
                })
                    .catch(function (err) { return _this.log(JSON.stringify(err)); });
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.database()
                    .ref("usersnew/".concat((0, Utils_1.email2UID)(email)))
                    .remove()
                    .then()
                    .catch(function (err) { return _this.log(JSON.stringify(err)); });
            }
            else {
                future.resolve(undefined);
            }
        })
            .catch(function (err) {
            _this.log('removeUserTempData#', err);
            future.resolve(undefined);
        });
        return future.promise;
    };
    return FirebaseAuth;
}());
exports.FirebaseAuth = FirebaseAuth;
//# sourceMappingURL=FirebaseAuth.js.map